import crud from './helpers/crud';

const BASE = '/api/v1/referral_templates';

const getReferralTemplates = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_REFERRAL_TEMPLATES',
      fail: 'FAILED_GET_REFERRAL_TEMPLATES',
      end: 'FINISH_GET_REFERRAL_TEMPLATES',
    },
    method: 'GET',
    url: BASE,
  })
);

// formData carries template_name, owner_type, owner_id, and the .docx `file`.
const createReferralTemplate = (formData) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_REFERRAL_TEMPLATE',
      fail: 'FAILED_CREATE_REFERRAL_TEMPLATE',
      end: 'FINISH_CREATE_REFERRAL_TEMPLATE',
    },
    method: 'POST',
    url: BASE,
    data: formData,
  })
);

const updateReferralTemplate = (slug, formData) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_REFERRAL_TEMPLATE',
      fail: 'FAILED_UPDATE_REFERRAL_TEMPLATE',
      end: 'FINISH_UPDATE_REFERRAL_TEMPLATE',
    },
    method: 'PATCH',
    url: `${BASE}/${slug}`,
    data: formData,
  })
);

const deleteReferralTemplate = (slug) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_REFERRAL_TEMPLATE',
      fail: 'FAILED_DELETE_REFERRAL_TEMPLATE',
      end: 'FINISH_DELETE_REFERRAL_TEMPLATE',
    },
    method: 'DELETE',
    url: `${BASE}/${slug}`,
  })
);

const duplicateReferralTemplate = (slug) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DUPLICATE_REFERRAL_TEMPLATE',
      fail: 'FAILED_DUPLICATE_REFERRAL_TEMPLATE',
      end: 'FINISH_DUPLICATE_REFERRAL_TEMPLATE',
    },
    method: 'POST',
    url: `${BASE}/${slug}/duplicate`,
  })
);

// With allDepartments, the API creates one copy per department and responds
// with the plural `referral_templates` key instead of `referral_template`.
const duplicateStarterTemplate = (starterKey, templateName, ownerType, ownerId, allDepartments = false) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DUPLICATE_STARTER_TEMPLATE',
      fail: 'FAILED_DUPLICATE_STARTER_TEMPLATE',
      end: 'FINISH_DUPLICATE_STARTER_TEMPLATE',
    },
    method: 'POST',
    url: `${BASE}/duplicate_starter`,
    data: {
      starter: starterKey,
      template_name: templateName,
      owner_type: ownerType,
      owner_id: ownerId,
      ...(allDepartments ? { all_departments: true } : {}),
    },
  })
);

// Returns the axios response; res.data is the .docx bytes (ArrayBuffer).
// The endpoint streams the file through Rails so this fetch is same-origin.
const downloadReferralTemplate = (slug) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DOWNLOAD_REFERRAL_TEMPLATE',
      fail: 'FAILED_DOWNLOAD_REFERRAL_TEMPLATE',
      end: 'FINISH_DOWNLOAD_REFERRAL_TEMPLATE',
    },
    method: 'GET',
    url: `${BASE}/${slug}/download`,
    responseType: 'arraybuffer',
  })
);

export {
  getReferralTemplates,
  createReferralTemplate,
  updateReferralTemplate,
  deleteReferralTemplate,
  duplicateReferralTemplate,
  duplicateStarterTemplate,
  downloadReferralTemplate,
};
